export default "__VITE_ASSET__BJv5GwLi__"